import { useState } from 'react';
import { C, t } from '../../Dashboard/components/dashboardConstants';

const FILTERS = ['전체', '드라마', '광고', '웹드라마', '영화'];

export default function ArchiveSearchBar() {
  const [filter, setFilter] = useState('전체');
  const [open, setOpen] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '24px' }}>
      {/* 검색창 */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '13px 18px', background: C.white,
        border: `1px solid ${C.g200}`, borderRadius: '10px', height: '50px', boxSizing: 'border-box',
      }}>
        <input
          placeholder="작품명, 역할, 제작사 검색..."
          style={{
            border: 'none', outline: 'none', background: 'transparent', flex: 1,
            ...t('18px', 400, C.g400), opacity: 0.7,
          }}
        />
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke={C.bk} strokeWidth="2"/>
          <path d="M16 16l4 4" stroke={C.bk} strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>

      {/* 필터 드롭다운 */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={() => setOpen(p => !p)}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '15px 18px', gap: '10px', width: '208px', height: '50px',
            background: C.white, border: `1px solid ${C.g200}`, borderRadius: '10px',
            cursor: 'pointer', boxSizing: 'border-box',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* filter icon */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M7 12h10M11 18h2" stroke={C.bk} strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span style={t('18px', 500, C.bk)}>{filter}</span>
          </div>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M6 9l6 6 6-6" stroke={C.bk} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {open && (
          <div style={{
            position: 'absolute', top: 'calc(100% + 6px)', right: 0,
            background: C.white, border: `1px solid ${C.g200}`,
            boxShadow: C.shadow, borderRadius: '12px',
            padding: '8px 0', minWidth: '160px', zIndex: 10,
          }}>
            {FILTERS.map(f => (
              <button key={f} onClick={() => { setFilter(f); setOpen(false); }} style={{
                display: 'block', width: '100%', padding: '10px 20px', textAlign: 'left',
                background: f === filter ? C.bg : 'transparent', border: 'none', cursor: 'pointer',
                ...t('16px', f === filter ? 600 : 400, f === filter ? C.bk : C.g500),
              }}>
                {f}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
